import * as Fa from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { DataTable } from "primereact/datatable";
import * as XLSX from "xlsx";
import { Column } from "primereact/column";
import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { InputNumber } from "primereact/inputnumber";
import { fetchData, postData } from "../../../../Services/GlobalService";
import PickListSchem from "./PickListSchem";
import { MultiSelect } from "primereact/multiselect";
import { toast } from "react-toastify";
import { downloadExcelDateFormat } from "../../../../Services/GlobalFunction/DownLoadExcel";
import { GetDateFormat } from "../../../../Services/GlobalFunction/GetDateFormat";
import ConfirmationPopUp from "../../../../Components/ConfirmationPopUp";
import Loader from "../../../../Components/Loader";
import { format } from "date-fns";
import { useNavigate, useSearchParams } from "react-router-dom";
import { InputSwitch } from "primereact/inputswitch";
import { debug } from "console";

export default function LineLevelInvd() {
  const nav = useNavigate();

  const segSpecificOpt = [
    { name: "Region", code: "REGN", Id: "17" },
    { name: "State", code: "STAT", Id: "16" },
    { name: "Distributor", code: "DIST", Id: "15" },
  ];

  const streamTypeopt = [
    { name: "B2B", code: "b2b" },
    { name: "B2C", code: "b2c" },
    { name: "INDUSTRIAL", code: "indst" },
    { name: "HD", code: "hd" },
  ];

  const [errors, setErrors] = useState<any>({});
  const [submitted, setSubmitted] = useState(false);
  const [schemeCode, setSchemeCode] = useState("");
  const [schemeCodeOriginal, setSchemeCodeOriginal] = useState("");
  const [schemeName, setSchemeName] = useState("");
  const [schmstartdt, setSchmstartdt] = useState<Date>();
  const [schmenddt, setSchmenddt] = useState<Date>();
  const [schmUploadType, setSchmUploadType] = useState<any>(null);
  const [schmUploadTypeview, setSchmUploadTypeview] = useState<any>("");
  const [schmUploadTypeOption, setSchmUploadTypeOption] = useState([]);
  const [activationsts, setActivationsts] = useState("Active");
  const [distLoading, setDistLoading] = useState<boolean>(false);
  const [streamType, setStreamType] = useState<any>(null);
  const [sourceDist, setSourceDist] = useState<any>([]);
  const [targetDist, setTargetDist] = useState<any>([]);
  const [sourceProd, setSourceProd] = useState<any>([]);
  const [allprodData, setAllprodData] = useState<any>([]);
  const [showErrorbtnprod, setShowErrorbtnprod] = useState<boolean>(false);
  const [prodSelcen, setProdSelcen] = useState<any>("Picklist");
  const [errorxlsProdData, setErrorxlsProdData] = useState<any>([]);
  const [tempprodUpLoading, setTempprodUpLoading] = useState<boolean>(false);
  const [showUpprodloading, setShowUpprodloading] = useState<boolean>(false);
  const [prodUploadsuccss, setProdUploadsuccss] = useState<boolean>(false);
  const [whileSave, setWhileSave] = useState<boolean>(false);
  const [viewSchmDetls, setViewSchmDetls] = useState<boolean>(false);
  const [wantupload, setWantupload] = useState<boolean>(false);
  const [excelCustdata, setExcelCustData] = useState<any>([]);
  const [errorxlsCustData, setErrorxlsCustData] = useState<any>([]);
  const [selectedSchm, setSelectedSchm] = useState<any>([]);
  const [targetProd, setTargetProd] = useState<any>([]);
  const [region, setRegion] = useState<any>();
  const [selectedRegion, setSelectedRegion] = useState<any>();
  const [state, setState] = useState<any>();
  const [selectedstate, setSelectedstate] = useState<any>();
  const [tempLoading, setTempLoading] = useState<boolean>(false);
  const [listofCategory, setListofCategory] = useState<any>([]);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [mappedCustProddata, setMappedCustProddata] = useState<any>([]);
  const [uploadedProd, setUploadedProd] = useState<any>([]);
  const [excelProdData, setExcelProdData] = useState<any>([]);
  const [schmDetailsData, setSchmDetailsData] = useState<any>([]);
  const [excelValidateFinaldta, setExcelValidateFinaldta] = useState<any>([]);
  const [excelFinaldta, setExcelFinaldta] = useState<any>([]);
  const [excelFinalerrordt, setExcelFinalerrordt] = useState<any>([]);
  const [distSelcen, setDistSelcen] = useState<any>("Picklist");
  const [excelDistData, setExcelDistData] = useState<any>([]);
  const [errorxlsDistData, setErrorxlsDistData] = useState<any>([]);
  const [tempDistUpLoading, setTempDistUpLoading] = useState<boolean>(false);
  const [showDistErrorbtn, setShowDistErrorbtn] = useState<boolean>(false);
  const [isDistUpload, setIsDistUpload] = useState<boolean>(false);
  const [tempDistLoading, setTempDistLoading] = useState<boolean>(false);
  const [pckdiscountval, setPckDiscountval] = useState<any>(null);
  const [csediscountval, setCseDiscountval] = useState<any>(null);

  const [showErrorbtn, setShowErrorbtn] = useState<boolean>(false);
  const [resetPopup, setResetPopup] = useState<boolean>(false);
  const [fileUpload, setFileUpload] = useState<boolean>(false);
  // const [fileUpSwt, setFileUpSwt] = useState<boolean>(false);
  const [IsFinalUpload, setIsFinalUpload] = useState<boolean>(false);

  const [tempUpLoading, setTempUpLoading] = useState(false);
  const [showUploading, setShowUploading] = useState(false);
  const [tempfinalUpLoading, setTempfinalUpLoading] = useState(false);
  const [showfinalUploading, setShowfinalUploading] = useState(false);
  const [ShowErrorbtnfinal, setShowErrorbtnfinal] = useState(false);
  const [resetloding, setResetloding] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [segSpecific, setSegSpecific] = useState<any>(segSpecificOpt[0]);

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileuploadDistRef = useRef<HTMLInputElement | null>(null);
  const prodfileInputRef = useRef<HTMLInputElement | null>(null);
  const filefinalInputRef = useRef<HTMLInputElement | null>(null);

  const [errorsDist, setErrorsDist] = useState({
    region: false,
    state: false,
    stream: false,
  });
  const [discountType, setDiscountType] = useState({
    name: "Percentage (%)",
    code: "PERCENT",
    key: "percentage",
    id: "PERCENT",
  });
  const discountTypeopt = [
    {
      name: "Percentage (%)",
      code: "PERCENT",
      key: "percentage",
      id: "PERCENT",
    },
    { name: "Value (₹)", code: "VLU", key: "value", id: "FLAT" },
  ];
  const CommonURl = "CommonDropdown";
  const Controller = "SchemeMultiDiscount";
  const EndPoint = {
    DropDownList: "DropDownList",
  };
  const SchmEndPoint = {
    SaveMultiLineDiscountData: "SaveMultiLineDiscountData",
    ValidationCustData: "ValidationCustData",
    DeleteSchemeCatgData: "DeleteSchemeCatgData",
    ValidationSegMentData: "ValidationSegMentData",
    GetAllSchemeCatgData: "GetAllSchemeCatgData",
    GetSavedLineLevelSchemeData: "GetSavedLineLevelSchemeData",
    GetDetailsSchemedata: "GetDetailsSchemedata",
    ValidationAllData: "ValidationAllData",
    ValidationProductData: "ValidationProductData",
    GetLineLevelSchemeCode: "GetLineLevelSchemeCode",
    UpdateLineLvlschm: "UpdateLineLvlschm",
    GetSchemeWiseCustSegdata: "GetSchemeWiseCustSegdata",
    ValidationDistributorData: "ValidationDistributorData",
  };

  const [schmCodeParam] = useSearchParams();
  let schmCode = schmCodeParam.get("schmID");

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const keyMap: any = {
    DIST_CODE: `${schmUploadType?.Name} Code`,
    DIST_NAME: `${schmUploadType?.Name} Name`,
    PROD_ID: "Product ID",
    PROD_DESC: "Product Description",
    PCKDISCAMT: `Pack Discount ${discountType?.key}`,
    CSEDISCAMT: `Case Discount ${discountType?.key}`,
  };
  const keyMapcategory: any = {
    DIST_CODE: "Category",
    PROD_ID: "Product ID",
    PROD_DESC: "Product Description",
    PCKDISCAMT: `Pack Discount ${discountType?.key}`,
    CSEDISCAMT: `Case Discount ${discountType?.key}`,
  };

  const keyMapRev: any = {
    [`${schmUploadType?.Name} Code`]: "DIST_CODE",
    [`${schmUploadType?.Name} Name`]: "DIST_NAME",
    "Product ID": "PROD_ID",
    "Product Description": "PROD_DESC",
    [`Pack Discount ${discountType?.key}`]: "PCKDISCAMT",
    [`Case Discount ${discountType?.key}`]: "CSEDISCAMT",
  };

  const keyMapCategoryRev: any = {
    Category: "DIST_CODE",
    "Product ID": "PROD_ID",
    "Product Description": "PROD_DESC",
    [`Pack Discount ${discountType?.key}`]: "PCKDISCAMT",
    [`Case Discount ${discountType?.key}`]: "CSEDISCAMT",
  };

  const validateForm = () => {
    const newErrors: any = {};
    // const schemeCodePattern = /^[a-zA-Z0-9]+$/; // only letters and numbers
    const schemeNamePattern = /^[a-zA-Z0-9\s()\[\]]+$/; // letters, numbers, spaces, ()[]

    if (!schemeName) {
      newErrors.schemeName = "Scheme Name is required";
    } else if (schemeName?.trim()?.length > 50) {
      newErrors.schemeName = "Scheme Name can't be more than 50";
    } else if (!schemeNamePattern.test(schemeName)) {
      newErrors.schemeName =
        "Scheme Name can only contain letters, numbers, spaces, and brackets ()[]";
    }
    if (!schmstartdt) newErrors.schmstartdt = "Start Date is required";
    if (!schmUploadType) newErrors.schmUploadType = "please select Upload Type";
    if (!schmenddt) newErrors.schmenddt = "End Date is required";
    if (!discountType) newErrors.discountType = "Discount Type is required";
    if (schmstartdt && schmenddt && schmenddt <= schmstartdt) {
      newErrors.schmenddt = "End Date must be greater than Start Date";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const UserId = localStorage.getItem("UserId")?.toString();
  let populateProduct = async () => {
    try {
      const prodres = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        `UserId=${UserId}&PVCtype=Scheme_Product_linelvl`,
      );
      setSourceProd(prodres?.Data);
      setAllprodData(prodres?.Data);
    } catch (error) {
      console.log(error);
    }
  };
  let convDDMMYYtoMMDDYY = (data: string) => {
    let [day, mon, yr] = data.toString().split("/");
    return `${mon}/${day}/${yr}`;
  };

  useEffect(() => {
    let getUploadType = async () => {
      try {
        const uploadTyperes = await fetchData(
          CommonURl,
          `${EndPoint.DropDownList}`,
          `UserId=${UserId}&PVCtype=Scheme_Line_Level`,
        );
        setSchmUploadTypeOption(uploadTyperes?.Data);
      } catch (error) {
        console.log(error);
      }
    };
    let getregion = async () => {
      try {
        const uploadTyperes = await fetchData(
          CommonURl,
          `${EndPoint.DropDownList}`,
          `UserId=${UserId}&PVCtype=Scheme_Region`,
        );
        setRegion(uploadTyperes?.Data);
      } catch (error) {
        console.log(error);
      }
    };
    let getHeadrDetils = async () => {
      try {
        const getHdrData = await fetchData(
          Controller,
          `${SchmEndPoint.GetSavedLineLevelSchemeData}`,
          `SCHEME_CODE=${schmCode}`,
        );
        setSchemeCodeOriginal(getHdrData.Data[0].SCHEME_CODE);
        setSchemeName(getHdrData.Data[0].SCHEME_NAME);
        setSchmstartdt(
          new Date(convDDMMYYtoMMDDYY(getHdrData.Data[0].START_DATE)),
        );
        setSchmenddt(new Date(convDDMMYYtoMMDDYY(getHdrData.Data[0].END_DATE)));
        let viewdistyp = discountTypeopt.filter(
          (item: any) =>
            item.id?.toUpperCase() ===
            getHdrData?.Data?.[0]?.DISCOUNT_TYPE?.toUpperCase(),
        )[0];
        setDiscountType(viewdistyp);
        setActivationsts(
          getHdrData.Data[0].ACTIVATION_STATUS == "ACTIVE"
            ? "Active"
            : "Inactive",
        );
        if (getHdrData.Data[0].ACTIVATION_STATUS == "INACTIVE") {
          setUpdateDisable(true);
        }
        setSelectedSchm(getHdrData.Data);
      } catch (error) {
        console.log(error);
      }
    };
    let GetDeatilsData = async () => {
      setDistLoading(true);
      try {
        const getdtlsDt = await fetchData(
          Controller,
          `${SchmEndPoint.GetDetailsSchemedata}`,
          `SCHEME_CODE=${schmCode}`,
        );
        setSchmDetailsData(getdtlsDt?.Data);
        setCseDiscountval(Number(getdtlsDt?.Data[0].CASE_PERCENTAGE));
        setPckDiscountval(Number(getdtlsDt?.Data[0].PACK_PERCENTAGE));
      } catch (error) {
        console.log(error);
      } finally {
        setDistLoading(false);
      }
    };
    if (schmCode === "null") {
      setViewSchmDetls(true);
      getUploadType();
      getregion();
      populateProduct();
      let rannum = Math.ceil(Math.random() * 100000);
      let schmname = `SchmInvd${rannum}`;
      setSchemeCode(schmname);
    } else {
      getUploadType();
      getHeadrDetils();
      GetDeatilsData();
    }
  }, []);

  type UploadType = {
    ID: string;
    Name: string;
  };

  useEffect(() => {
    if (!schmUploadTypeOption?.length || !selectedSchm?.length) return;

    const selectedOption = (schmUploadTypeOption as UploadType[]).find(
      (opt) => opt.ID == selectedSchm[0]?.UPLOAD_TYPE,
    );

    setSchmUploadTypeview(selectedOption?.Name || "Segment");
  }, [selectedSchm, schmUploadTypeOption]);

  const itemTemplatePanelDist = (item: any) => {
    return (
      <span>
        {item?.Distributor_Code} ({item?.Distributor_Name})
      </span>
    );
  };
  const itemTemplatePanelProd = (item: any) => {
    return (
      <span>
        {item?.Product_ID} ({item?.Product_Description})
      </span>
    );
  };

  const handleRegion = (e: any) => {
    const selectedRegions = e?.value;
    setSelectedRegion(e?.value);
    const selectedregionValus = selectedRegions
      .map((item: any) => `${item?.Region_ID}`)
      .join(",");
    stateCallfun(selectedregionValus === "" ? "All" : selectedregionValus);
  };

  let stateCallfun = async (region: any) => {
    try {
      const uploadTyperes = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        `UserId=${UserId}&PVCtype=Scheme_State&PVCPAYLOAD=${JSON.stringify({
          Region: region,
        })}`,
      );
      setState(uploadTyperes.Data);
    } catch (error) {
      console.log(error);
    }
  };

  const populateDistlst = () => {
    const newErrors = {
      region: selectedRegion.length === 0,
      state: selectedstate.length === 0,
      stream: !streamType,
    };

    setErrorsDist(newErrors);

    if (Object.values(newErrors).includes(true)) {
      return;
    } else {
      setTargetDist([]);
      const selectedstateValus = selectedstate
        .map((item: any) => `${item.State_ID}`)
        .join(",");
      const selectedRegionValues = selectedRegion
        .map((item: any) => `${item.Region_ID}`)
        .join(",");
      getAllDistributorList(
        selectedstateValus,
        streamType?.name,
        selectedRegionValues,
      );
    }
  };

  let getAllDistributorList = async (
    statelst: any,
    segmentlst: any,
    regionlst: any,
  ) => {
    try {
      setDistLoading(true);
      const uploadTyperes = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        `UserId=${UserId}&PVCtype=Scheme_Distributor&PVCPAYLOAD=${JSON.stringify(
          {
            State: statelst,
            Stream: segmentlst,
            Region: regionlst,
            UserId: UserId,
          },
        )}`,
      );
      if (uploadTyperes?.Data?.length == 0 || uploadTyperes?.Data == null) {
        toast.warn("No distributor found.");
      }
      setSourceDist(uploadTyperes.Data);
    } catch (error) {
      console.log(error);
    } finally {
      setDistLoading(false);
    }
  };
  // --------------------DISTRIBUTOR UPLOAD---------------------

 let downloadTemptDist = async() => {
      if(streamType?.name==null){
        toast.warn("Please select a stream type.");
        return;
      } 
      let fileName = `Template_Distributor${GetDateFormat()}.xlsx`;
      try {
        setTempDistLoading(true);
      const prodres = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        `UserId=${UserId}&PVCtype=Line_Lvl_Dist_All&PVCPAYLOAD=${JSON.stringify({
          stream: streamType?.name,
        })}`,
      );
      downloadExcelDateFormat(prodres.Data, fileName);
    } catch (error) {
      console.log(error);
    }finally{
      setTempDistLoading(false);
    }
      
    };

  let excelErrorDistDownload = () => {
    let fileName = `Template_Distributor_Error${GetDateFormat()}.xlsx`;
    downloadExcelDateFormat(errorxlsDistData, fileName);
  };

  let handleDistFileUploadXL = (event: React.ChangeEvent<HTMLInputElement>) => {
    setExcelDistData([]);
    const file = event?.target?.files?.[0];
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!file) return;
    if (file && !fileTypes.includes(file.type)) {
      toast.warn("Please specify a valid file. Can upload only Excel file");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        defval: "",
        blankrows: false,
      });

      const filteredData = jsonData.filter((row) =>
        Object.values(row).some((value) => value !== ""),
      );

      if (!filteredData.length) {
        toast.warn("The Excel file has no valid data.");
        return;
      }

      const expectedHeaders = ["Distributor Code", "Distributor Name"];

      const actualHeaders = Object.keys(filteredData[0]).map((h) => h.trim());

      const missingHeaders = expectedHeaders.filter(
        (header) => !actualHeaders.includes(header),
      );

      if (missingHeaders.length > 0) {
        toast.warn(`Missing required columns: ${missingHeaders.join(", ")}`);
        if (fileuploadDistRef.current) {
          fileuploadDistRef.current.value = "";
        }
        return;
      }
      setExcelDistData(filteredData);
    };

    reader.readAsArrayBuffer(file);
  };

  let handleDistValidateCustXL = async () => {
    setShowDistErrorbtn(false);
    setTempDistUpLoading(true);

    try {
      let distValidPyld = {
        disT_VALID_TYPE_DATA: excelDistData.map((item: any) => ({
          distributoR_CODE: item["Distributor Code"],
          // distributoR_NAME: item["Distributor Name"],
        })),
      };
      const validationCustSegRes = await postData(
        Controller,
        `${SchmEndPoint.ValidationDistributorData}`,
        distValidPyld,
      );
      if (validationCustSegRes?.Message === "Warning") {
        toast.warn("There are errors in file upload.");
        setErrorxlsDistData(validationCustSegRes.Data);
        setExcelDistData([]);
        setShowDistErrorbtn(true);
        if (fileuploadDistRef.current) {
          fileuploadDistRef.current.value = "";
        }
      } else {
        const result = excelDistData.map((item: any) => ({
          Distributor_Code: item["Distributor Code"],
          Distributor_Name: item["Distributor Name"],
        }));
        setTargetDist(result);
        setIsDistUpload(true);
        toast.success("Data uploaded succesfully");
      }
    } catch (e: any) {
      toast.error(`${e.response.data.Message}`);
    } finally {
      setTempDistUpLoading(false);
    }
  };

  //#region Customer/Segment

  const allowedTypes = useMemo(() => new Set([10, 15, 16, 17, 20]), []);

  const downlodTempt = async () => {
    let listDist = targetDist
      .map((item: any) => item.Distributor_Code)
      .join(",");
    try {
      setTempLoading(true);
      let custUrl = `UserId=${UserId}&PVCtype=Scheme_Customer_Line&PVCPAYLOAD=${JSON.stringify(
        {
          Distributor: listDist,
        },
      )}`;
      let streamUrl = `UserId=${UserId}&PVCtype=Scheme_Segment_Line&PVCPAYLOAD=${JSON.stringify(
        {
          Stream: streamType.name,
        },
      )}`;
      const uploadTyperes = await fetchData(
        CommonURl,
        `${EndPoint.DropDownList}`,
        schmUploadType?.Name == "Customer" ? custUrl : streamUrl,
      );
      let fileName = `Template_${schmUploadType?.Name}.xlsx`;
      downloadExcelDateFormat(uploadTyperes.Data, fileName);
    } catch (error) {
      console.log(error);
    } finally {
      setTempLoading(false);
    }
  };

  let handleFileUploadXL = (event: React.ChangeEvent<HTMLInputElement>) => {
    setExcelCustData([]);
    const file = event?.target?.files?.[0];
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!file) return;
    if (file && !fileTypes.includes(file.type)) {
      toast.warn("Please specify a valid file. Can upload only Excel file");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        defval: "",
        blankrows: false,
      });

      const filteredData = jsonData.filter((row) =>
        Object.values(row).some((value) => value !== ""),
      );

      if (!filteredData.length) {
        toast.warn("The Excel file has no valid data.");
        return;
      }

      const expectedHeaders =
        schmUploadType?.Name == "Customer"
          ? [
              "Distributor Code",
              "Customer Code",
              "Customer Name",
              "Segment Code",
              "Category",
            ]
          : ["Segment Code", "Segment Name", "Category"];

      const actualHeaders = Object.keys(filteredData[0]).map((h) => h.trim());

      const missingHeaders = expectedHeaders.filter(
        (header) => !actualHeaders.includes(header),
      );

      if (missingHeaders.length > 0) {
        toast.warn(`Missing required columns: ${missingHeaders.join(", ")}`);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }
      setExcelCustData(filteredData);
    };

    reader.readAsArrayBuffer(file);
  };

  let handleValidateCustXL = async () => {
    setShowErrorbtn(false);
    setTempUpLoading(true);
    setShowUploading(false);

    const timer = setTimeout(() => {
      setShowUploading(true);
    }, 2000);

    try {
      let excelValidation = [];
      let listDist = "";

      if (schmUploadType?.Name == "Customer") {
        listDist = targetDist
          .map((item: any) => item.Distributor_Code)
          .join(",");
        excelValidation = excelCustdata.map((item: any) => ({
          distributoR_CODE: item["Distributor Code"],
          cusT_CODE: item["Customer Code"],
          cust_name: item["Customer Name"],
          segmenT_CODE: item["Segment Code"],
          catG_CODE: item["Category"],
        }));
      } else {
        excelValidation = excelCustdata.map((item: any) => ({
          segmenT_CODE: item["Segment Code"],
          segmenT_DESC: item["Segment Name"],
          catG_CODE: item["Category"],
        }));
      }

      let custValidPyld =
        schmUploadType?.Name == "Customer"
          ? {
              cusT_VALID_TYPE_DATA: excelValidation,
              schemE_CODE: schemeCode,
              useR_ID: UserId,
              dB_ID: listDist,
            }
          : {
              seG_VALID_TYPE_DATA: excelValidation,
              schemE_CODE: schemeCode,
              useR_ID: UserId,
              streaM_CODE: streamType.name,
            };

      const validationCustSegRes = await postData(
        Controller,
        `${
          schmUploadType?.Name == "Customer"
            ? SchmEndPoint.ValidationCustData
            : SchmEndPoint.ValidationSegMentData
        }`,
        custValidPyld,
      );
      if (validationCustSegRes?.Message === "Warning") {
        toast.warn("There are errors in file upload.");
        setErrorxlsCustData(validationCustSegRes.Data);
        setExcelCustData([]);
        setShowErrorbtn(true);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        toast.success("Data uploaded succesfully");
        fetchCategory();
        setFileUpload(true);
      }
    } catch (e: any) {
      toast.error(`${e.response.data.Message}`);
    } finally {
      clearTimeout(timer);
      setTempUpLoading(false);
      setShowUploading(false);
    }
  };

  const fetchCategory = async () => {
    try {
      setDistLoading(true);
      let schmtyp = schmUploadType?.Name == "Customer" ? "Cust" : "Seg";
      const getcatTyperes = await fetchData(
        Controller,
        `${SchmEndPoint.GetAllSchemeCatgData}`,
        `SCHEME_CODE=${schemeCode}&USERID=${UserId}&SCHM_TYPE=${schmtyp}`,
      );

      setListofCategory(getcatTyperes.Data);
    } catch (error) {
      console.log(error);
    } finally {
      setDistLoading(false);
    }
  };

  const excelErrorCustDownload = () => {
    downloadExcelDateFormat(
      errorxlsCustData,
      `Error_${schmUploadType?.Name}_Validate_${GetDateFormat()}.xlsx`,
    );
  };

  //#endregion

  //#region Product

  let downloadTeampltprod = async () => {
    let fileName = `Template_Product.xlsx`;
    let mappedprod = sourceProd.map((item: any) => ({
      ["Product ID"]: item.Product_ID,
      ["Product Description"]: item.Product_Description,
      ["Pack Size"]: item.PACK_FACTOR,
      Category: null,
      Pack: null,
      Case: null,
    }));
    let mappedstreg = sourceProd.map((item: any) => ({
      ["Product ID"]: item.Product_ID,
      ["Product Description"]: item.Product_Description,
      ["Pack Size"]: item.PACK_FACTOR,
      Pack: null,
      Case: null,
    }));
    let prodexldown =
      schmUploadType?.Name == "Customer" || schmUploadType?.Name == "Segment"
        ? mappedprod
        : mappedstreg;
    downloadExcelDateFormat(prodexldown, fileName);
  };

  let handleFileProdup = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files?.[0];
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!file) return;
    if (file && !fileTypes.includes(file.type)) {
      toast.warn("Please specify a valid file. Can upload only Excel file");
      if (prodfileInputRef.current) {
        prodfileInputRef.current.value = "";
      }
      return;
    }
    setShowErrorbtnprod(false);

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        defval: "",
        blankrows: false,
      });

      const filteredData = jsonData.filter((row) =>
        Object.values(row).some((value) => value !== ""),
      );

      if (!filteredData.length) {
        toast.warn("The Excel file has no valid data.");
        return;
      }
      let expectedHeaders =
        schmUploadType?.Name === "Customer" ||
        schmUploadType?.Name === "Segment"
          ? ["Product ID", "Product Description", "Category", "Pack", "Case"]
          : ["Product ID", "Product Description", "Pack", "Case"];

      const actualHeaders = Object.keys(filteredData[0]).map((h) => h.trim());

      const missingHeaders = expectedHeaders.filter(
        (header) => !actualHeaders.includes(header),
      );

      if (missingHeaders.length > 0) {
        toast.warn(`Missing required columns: ${missingHeaders.join(", ")}`);
        if (prodfileInputRef.current) {
          prodfileInputRef.current.value = "";
        }
        return;
      }
      setExcelProdData(filteredData);
    };

    reader.readAsArrayBuffer(file);
  };

  let handleValidateProdXL = async () => {
    if (
      (schmUploadType?.Name === "Customer" ||
        schmUploadType?.Name === "Segment") &&
      !fileUpload
    ) {
      toast.warn(`please upload ${schmUploadType?.Name} file first`);
      return;
    }
    setTargetProd([]);
    setShowErrorbtnprod(false);
    setTempprodUpLoading(true);
    setShowUpprodloading(false);
    setProdUploadsuccss(false);

    const timer = setTimeout(() => {
      setShowUploading(true);
    }, 1000);

    try {
      let prodValid = excelProdData.map((item: any) => ({
        proD_ID: item["Product ID"],
        proD_DESC: item["Product Description"],
        catG_CODE:
          schmUploadType?.Name === "Customer" ||
          schmUploadType?.Name === "Segment"
            ? item["Category"]
            : "",
        pckdisc: item.Pack,
        casedisc: item.Case,
      }));

      // setUploadedProd(excelProdData);

      let payloadprod = {
        proD_VALID_TYPE_DATA: prodValid,
        leveL_ID: schmUploadType.ID,
        schemE_CODE: schemeCode,
        disctype: discountType.code,
        schmtype: "INVD",
      };

      const validationProdRes = await postData(
        Controller,
        SchmEndPoint.ValidationProductData,
        payloadprod,
      );
      if (validationProdRes?.Message === "Warning") {
        toast.warn("There are errors in file upload.");
        setErrorxlsProdData(validationProdRes.Data);
        setShowErrorbtnprod(true);
        setExcelProdData([]);
      } else {
        toast.success("Data uploaded succesfully");
        setProdUploadsuccss(true);
        setUploadedProd(validationProdRes.Data);
        setExcelProdData([]);
        if (prodfileInputRef.current) {
          prodfileInputRef.current.value = "";
        }
      }
    } catch (e: any) {
      toast.error(`${e.response.data.Message}`);
    } finally {
      clearTimeout(timer);
      setTempprodUpLoading(false);
      setShowUpprodloading(false);
    }
  };

  const excelErrorprodDownload = () => {
    downloadExcelDateFormat(
      errorxlsProdData,
      `Error_Product_Validate_${GetDateFormat()}.xlsx`,
    );
  };

  //#endregion

  function mapUploadData(uploadType: any, data: any[]) {
    switch (uploadType) {
      case "30":
        return data.map((d) => ({
          keyId: d.Distributor_Code,
          Valuename: d.Distributor_Name,
          type: "DISTRIBUTOR",
        }));

      case "40":
        return data.map((s) => ({
          keyId: s.State_ID,
          Valuename: s.State_Name,
          type: "STATE",
        }));

      case "50":
        return data.map((r) => ({
          keyId: r.Region_ID,
          Valuename: r.Region_Description,
          type: "REGION",
        }));

      default:
        return [];
    }
  }

  const getCatMsg = (id: any) => {
    switch (id) {
      case "10":
        return "Customer";
      case "20":
        return "Category";
      case "30":
        return "Distributor";
      case "40":
        return "State";
      case "50":
        return "Region";
    }
  };

  //#region  Add to cart
  const addproductcart = () => {
    setSubmitted(true);
    if (!validateForm()) return;

    if (schmUploadType?.Name === "Segment" && streamType == null) {
      toast.warn("Please select one Stream");
      return;
    }

    if (schmUploadType?.Name === "Distributor" && targetDist?.length === 0) {
      toast.warn("Please select at least one Distributor");
      return;
    }
    if (schmUploadType?.Name === "State" && selectedstate?.length === 0) {
      toast.warn("Please select at least one State");
      return;
    }
    if (schmUploadType?.Name === "State" && streamType == null) {
      toast.warn("Please select one Stream");
      return;
    }
    if (schmUploadType?.Name === "Region" && selectedRegion?.length === 0) {
      toast.warn("Please select at least one Region");
      return;
    }
    if (schmUploadType?.Name === "Region" && streamType == null) {
      toast.warn("Please select one Stream");
      return;
    }

    if (schmUploadType?.ID === "15" && streamType == null) {
      toast.warn("Please select one Stream");
      return;
    }

    if (prodSelcen == "Picklist" && targetProd?.length === 0) {
      toast.warn("Please select at least one Product");
      return;
    }
    if (prodSelcen == "Upload" && uploadedProd?.length === 0) {
      toast.warn("Please upload at least one Product");
      return;
    }
    if (
      (schmUploadType?.Name === "Customer" ||
        schmUploadType?.Name === "Segment") &&
      !fileUpload
    ) {
      toast.warn(`Please upload at least one ${schmUploadType?.Name}`);
      return;
    }
    if (
      (schmUploadType?.Name === "Customer" ||
        schmUploadType?.Name === "Segment") &&
      selectedCategory == null &&
      prodSelcen == "Picklist"
    ) {
      toast.warn("Please select one category");
      return;
    }

    if (
      prodSelcen == "Upload" &&
      (schmUploadType?.Name === "Customer" ||
        schmUploadType?.Name === "Segment")
    ) {
      setMappedCustProddata((prev: any) => {
        const existingKeys = new Set(
          prev.map((r: any) => `${r.PROD_ID}-${r.DIST_CODE}`),
        );
        const newRows: any[] = [];
        const attemptedKeys = new Set();
        let duplicateCount = 0;
        let mappedProddata = uploadedProd; //uploaded data with category from excel data
        mappedProddata.forEach((prod: any) => {
          const category = prod.category; // Use product category directly
          const key = `${prod.Product_ID}-${category}`;

          // Already exists in state
          if (existingKeys.has(key)) {
            duplicateCount++;
            return;
          }

          // Duplicate in same attempt
          if (attemptedKeys.has(key)) {
            duplicateCount++;
            return;
          }

          attemptedKeys.add(key);

          newRows.push({
            id: key,
            DIST_CODE: category, // Category used as distributor from excel key
            PROD_ID: prod.Product_ID,
            PROD_DESC: prod.Product_Description,
            CATEGORY: category,
            PCKDISCAMT: prod.pckdisc ?? "0",
            CSEDISCAMT: prod.casedisc ?? "0",
          });
        });

        if (newRows.length === 0 && duplicateCount > 0) {
          toast.warn("Uploaded category products already mapped");
          return prev;
        }

        if (duplicateCount > 0) {
          toast.info(`${duplicateCount} duplicate product-category skipped`);
        }

        return [...prev, ...newRows];
      });
      setUploadedProd([]);
      setExcelProdData([]);
    } else {
      setMappedCustProddata((prev: any) => {
        const existingKeys = new Set(
          prev.map((r: any) => `${r.PROD_ID}-${r.DIST_CODE}`),
        );

        const newRows: any[] = [];
        const attemptedKeys = new Set();
        let duplicateCount = 0;

        const mappedUploadDt =
          schmUploadType.ID === "30"
            ? targetDist
            : schmUploadType.ID === "40"
              ? selectedstate
              : selectedRegion;

        const mappeddata =
          schmUploadType?.Name === "Customer" ||
          schmUploadType?.Name === "Segment"
            ? [selectedCategory]
            : mapUploadData(schmUploadType.ID, mappedUploadDt);

        const mappedProddata =
          prodSelcen == "Picklist" ? targetProd : uploadedProd;

        mappedProddata.forEach((prod: any) => {
          mappeddata.forEach((dist: any) => {
            // Correct unique key: Product_ID + Distributor
            const key = `${prod.Product_ID}-${dist.keyId}`;

            // Duplicate against existing state
            if (existingKeys.has(key)) {
              duplicateCount++;
              return;
            }

            // Duplicate within same attempt
            if (attemptedKeys.has(key)) {
              duplicateCount++;
              return;
            }

            attemptedKeys.add(key);

            newRows.push({
              id: key,
              keyId: dist.keyId,
              DIST_CODE: dist.keyId,
              DIST_NAME: dist.Valuename,
              PROD_ID: prod.Product_ID, // consistent usage
              PROD_DESC: prod.Product_Description,
              PCKDISCAMT: prod.pckdisc ?? "0",
              CSEDISCAMT: prod.casedisc ?? "0",
            });
          });
        });

        if (newRows.length === 0 && duplicateCount > 0) {
          toast.warn(
            `This ${getCatMsg(schmUploadType?.ID)} is already mapped with the selected product`,
          );
          return prev;
        }

        if (duplicateCount > 0) {
          toast.info(`${duplicateCount} duplicate combination(s) skipped`);
        }

        return [...prev, ...newRows];
      });
      setUploadedProd([]);
      setExcelProdData([]);
    }

    // clear selections after add
    if (schmUploadType.Name == "Distributor") {
      setTargetDist([]);
    }
    if (schmUploadType.Name == "State") {
      setSelectedstate([]);
      setSelectedRegion([]);
    }
    if (schmUploadType.Name == "Region") {
      setSelectedRegion([]);
    }
    if (prodSelcen == "Upload") {
      if (prodfileInputRef.current) {
        prodfileInputRef.current.value = "";
      }
    }
    // if (
    //   schmUploadType?.Name === "Customer" ||
    //   schmUploadType?.Name === "Segment"
    // ) {
    //   if (fileInputRef.current) {
    //     fileInputRef.current.value = "";
    //   }
    // }
    setSelectedCategory(null);
    setTargetProd([]);
    setPckDiscountval(null);
    setCseDiscountval(null);
    setSourceProd(allprodData);
  };

  // #endregion

  // console.log(mappedCustProddata, "mappedCustProddata");

  const onQuantityChangepck = useCallback((rowId: any, value: any) => {
    setMappedCustProddata((prev: any) =>
      prev.map((row: any) =>
        row.id === rowId ? { ...row, PCKDISCAMT: value?.toString() } : row,
      ),
    );
  }, []);

  const onQuantityChangecse = useCallback((rowId: any, value: any) => {
    setMappedCustProddata((prev: any) =>
      prev.map((row: any) =>
        row.id === rowId ? { ...row, CSEDISCAMT: value?.toString() } : row,
      ),
    );
  }, []);

  const deleteRow = useCallback((rowId: any) => {
    setMappedCustProddata((prev: any) =>
      prev.filter((row: any) => row.id !== rowId),
    );
  }, []);

  //#region JSON create

  const transformData = (data: any[]) => {
    // Group by DIST_CODE
    const grouped = data.reduce((acc: any, item: any) => {
      if (!acc[item.DIST_CODE]) {
        acc[item.DIST_CODE] = [];
      }
      acc[item.DIST_CODE].push(item);
      return acc;
    }, {});
    const schemeLevels: any[] = [];
    const tvpSchemeProdMap: any[] = [];

    let schemeCodeCounter = 1;

    Object.keys(grouped).forEach((distCode) => {
      const currentSchemeCode = schemeCodeCounter.toString();
      const items = grouped[distCode];

      // Scheme Level Entry
      schemeLevels.push({
        schm_cat: currentSchemeCode,
        schm_level_no: schmUploadType.ID,
        ref_schm_level_id: [distCode],
      });

      //Collect as ARRAYS (not strings)
      const productIds = items.map((i: any) => i.PROD_ID);
      const packDiscounts = items.map((i: any) => i.PCKDISCAMT);
      const caseDiscounts = items.map((i: any) => i.CSEDISCAMT);

      tvpSchemeProdMap.push({
        schm_cat: currentSchemeCode,
        prod_id: productIds,
        discount_type: discountType.id,
        discount_pack: packDiscounts,
        discount_case: caseDiscounts,
        schm_level_no: schmUploadType.ID,
      });

      schemeCodeCounter++;
    });

    return {
      schm_holder_map_line_lvl: schemeLevels,
      schm_prod_map_line_lvl: tvpSchemeProdMap,
    };
  };

  const transformDatacustseg = (data: any[], customers: any[]) => {
    // Group products by DIST_CODE (Category)
    const grouped = data.reduce((acc: any, item: any) => {
      if (!acc[item.DIST_CODE]) {
        acc[item.DIST_CODE] = [];
      }
      acc[item.DIST_CODE].push(item);
      return acc;
    }, {});
    let schmlvlno = "";
    schmlvlno = schmUploadType?.ID == 15 ? segSpecific?.Id : schmUploadType?.ID;
    const schemeLevels: any[] = [];
    const tvpSchemeProdMap: any[] = [];

    let schemeCodeCounter = 1;

    Object.keys(grouped).forEach((distCode) => {
      const currentSchemeCode = schemeCodeCounter.toString();
      const items = grouped[distCode];

      //  Get all customers matching this category
      const matchingCustomers = customers
        .filter((cust: any) => cust.Category === distCode)
        .map((cust: any) => cust["CUST_ID"]); //customer code or id

      const customerCodesCSV = matchingCustomers;

      //  Scheme Level Entry
      schemeLevels.push({
        schm_cat: currentSchemeCode,
        schm_level_no: schmlvlno,
        ref_schm_level_id: customerCodesCSV, //Comma separated cust codes
      });

      // Product Arrays
      const productIds = items.map((i: any) => i.PROD_ID);
      const packDiscounts = items.map((i: any) => i.PCKDISCAMT);
      const caseDiscounts = items.map((i: any) => i.CSEDISCAMT);

      tvpSchemeProdMap.push({
        schm_cat: currentSchemeCode,
        prod_id: productIds,
        discount_type: discountType.id,
        discount_pack: packDiscounts,
        discount_case: caseDiscounts,
        schm_level_no: schmlvlno,
      });

      schemeCodeCounter++;
    });

    return {
      schm_holder_map_line_lvl: schemeLevels,
      schm_prod_map_line_lvl: tvpSchemeProdMap,
    };
  };

  const submitSchmDisc = async () => {
    try {
      if (!schmUploadType?.Name) {
        console.error("Upload type is missing");
        return;
      }
      if (!IsFinalUpload && wantupload) {
        toast.warn("Please upload the file");
        return;
      }
      if(streamType?.name==null){
        toast.warn("Please select a stream type.");
        return;
      } 
      setWhileSave(true);
      const uploadType = schmUploadType?.Name;
      let result;
      if (uploadType === "Customer" || uploadType === "Segment") {
        const schmtyp = uploadType === "Customer" ? "CustAll" : "SegAll";

        const getcatTyperes = await fetchData(
          Controller,
          SchmEndPoint.GetAllSchemeCatgData,
          `SCHEME_CODE=${schemeCode}&USERID=${UserId}&SCHM_TYPE=${schmtyp}`,
        );

        result = transformDatacustseg(
          mappedCustProddata,
          getcatTyperes?.Data || [],
        );
      } else {
        result = transformData(mappedCustProddata);
      }
      let schmlvlno = "";
      const mapping: any = {
        STAT: selectedstate?.map((item: any) => item.State_ID),
        REGN: selectedRegion?.map((item: any) => item.Region_ID),
        DIST: targetDist?.map((item: any) => item.Distributor_Code),
      };

      let filterValues =
        schmUploadType?.ID == 15
          ? mapping[segSpecific?.code]?.join(",") || ""
          : "";

      schmlvlno =
        schmUploadType?.ID == 15 ? segSpecific?.Id : schmUploadType?.ID;

      const finalPayload = {
        schm_info_line_lvl: [
          {
            master_schm_code: "",
            schm_name: schemeName,
            start_date: format(schmstartdt ?? "", "dd/MM/yyyy"),
            end_date: format(schmenddt ?? "", "dd/MM/yyyy"),
            schm_level_no: schmlvlno,
            is_active: activationsts == "Active" ? "Y" : "N",
            enter_by: UserId,
            promo_included: "N",
            is_combined: "N",
            segment_filt: [filterValues],
            stream_type: `${streamType.name}`,
          },
        ],
        ...result,
      };

      // console.log(finalPayload);
      //  setWhileSave(false);
      // return;
      const saveSchmData = await postData(
        Controller,
        `${SchmEndPoint.SaveMultiLineDiscountData}`,
        finalPayload,
      );
      console.log("saveSchmData", saveSchmData);
      toast.success(`${saveSchmData.message}`);
      nav("/Master/Scheme/SchemeDiscDefAllRec");
      setWhileSave(false);
    } catch (error: any) {
      console.error("Error in submitSchmDisc:", error);

      toast.error(error?.response?.data?.Message);
    } finally {
      setWhileSave(false);
    }
  };

  //#endregion

  const downloadFinalmappedData = () => {
    let updatedData = [];
    if (
      schmUploadType.Name == "State" ||
      schmUploadType.Name == "Region" ||
      schmUploadType.Name == "Distributor"
    ) {
      updatedData = mappedCustProddata.map((obj: any) => {
        const { id, keyId, ...rest } = obj;

        return Object.keys(rest).reduce((acc: any, key: any) => {
          const newKey = keyMap[key] || key;
          acc[newKey] = rest[key];
          return acc;
        }, {});
      });
    } else {
      updatedData = mappedCustProddata.map((obj: any) => {
        const { id, keyId, DIST_NAME, CATEGORY, ...rest } = obj;
        return Object.keys(rest).reduce((acc: any, key: any) => {
          const newKey = keyMapcategory[key] || key;
          acc[newKey] = rest[key];
          return acc;
        }, {});
      });
    }
    let flname = `${schmUploadType.Name}_wise_SchmData.xlsx`;

    downloadExcelDateFormat(updatedData, flname);
  };

  //#region Reset Data
  let ResetAlldata = async (show: boolean = true) => {
    if (resetloding) return;
    let ressetplyd = {
      schemE_CODE: schemeCode,
      useR_ID: UserId,
      TYPE: schmUploadType?.Name ?? "",
    };
    try {
      setResetloding(true);
      const resettingRes = await postData(
        Controller,
        SchmEndPoint.DeleteSchemeCatgData,
        ressetplyd,
      );
      if (resettingRes.Status == "Success") {
        if (show) {
          toast.success("Data reset successfully");
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setFileUpload(false);
      setShowErrorbtnfinal(false);
      setResetloding(false);
      setPckDiscountval(null);
      setCseDiscountval(null);
      setSelectedCategory(null);
      setListofCategory([]);
      setSelectedstate([]);
      setSelectedRegion([]);
      setErrorxlsCustData([]);
      setSourceDist([]);
      setTargetDist([]);
      setStreamType(null);
      setMappedCustProddata([]);
      setExcelCustData([]);
      setTargetProd([]);
      setExcelProdData([]);
      setUploadedProd([]);
      setResetPopup(false);
      setShowErrorbtnprod(false);
      setShowErrorbtn(false);
      setIsFinalUpload(false);
      setProdUploadsuccss(false);
      setIsDistUpload(false);
      setShowDistErrorbtn(false);
      setExcelDistData([]);
      setSegSpecific(segSpecificOpt[0]);
      if (filefinalInputRef.current) {
        filefinalInputRef.current.value = "";
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      if (prodfileInputRef.current) {
        prodfileInputRef.current.value = "";
      }
    }
  };
  //#endregion

  //#region valiadtionFinal

  const mapKeys = (data: any[], map: any) => {
    return data.map((obj: any) =>
      Object.entries(obj).reduce((acc: any, [key, value]) => {
        const newKey = map[key] || key;
        acc[newKey] = value;
        return acc;
      }, {}),
    );
  };

  const handleValidateFinalData = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event?.target?.files?.[0];
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!file) return;
    if (file && !fileTypes.includes(file.type)) {
      toast.warn("Please specify a valid file. Can upload only Excel file");
      if (filefinalInputRef.current) {
        filefinalInputRef.current.value = "";
      }
      return;
    }
    setShowErrorbtnfinal(false);

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        defval: "",
        blankrows: false,
      });
      const filteredData = jsonData.filter((row) =>
        Object.values(row).some((value) => value !== ""),
      );

      if (!filteredData.length) {
        toast.warn("The Excel file has no valid data.");
        return;
      }
      const keyMapfnl = [
        `${schmUploadType?.Name} Code`,
        `${schmUploadType?.Name} Name`,
        "Product ID",
        "Product Description",
        `Pack Discount ${discountType?.key}`,
        `Case Discount ${discountType?.key}`,
      ];
      const keyMapcategoryfnl = [
        "Category",
        "Product ID",
        "Product Description",
        `Pack Discount ${discountType?.key}`,
        `Case Discount ${discountType?.key}`,
      ];
      let expectedHeaders =
        schmUploadType?.Name === "Customer" ||
        schmUploadType?.Name === "Segment"
          ? keyMapcategoryfnl
          : keyMapfnl;

      const actualHeaders = Object.keys(filteredData[0]).map((h) => h.trim());
      const missingHeaders = expectedHeaders.filter(
        (header: any) => !actualHeaders.includes(header),
      );

      if (missingHeaders.length > 0) {
        toast.warn(`Missing required columns: ${missingHeaders.join(", ")}`);
        if (prodfileInputRef.current) {
          prodfileInputRef.current.value = "";
        }
        return;
      }

      const isGeoType = ["State", "Region", "Distributor"].includes(
        schmUploadType?.Name,
      );

      const updatedData = isGeoType
        ? mapKeys(filteredData, keyMapRev)
        : mapKeys(filteredData, keyMapCategoryRev);

      setExcelValidateFinaldta(updatedData);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleFinalFileUpload = async () => {
    setShowErrorbtnfinal(false);
    setTempfinalUpLoading(true);
    setShowfinalUploading(false);
    let prddata = excelValidateFinaldta.map((item: any) => ({
      commoN_FIELD: item.DIST_CODE,
      producT_CODE: item.PROD_ID,
      pckdisc: item.PCKDISCAMT,
      csedisk: item.CSEDISCAMT,
    }));
    let finalvldpyld = {
      proD_VALID_ALL_DATA: prddata,
      leveL_ID: schmUploadType.ID,
      schemE_CODE: schemeCode,
      type: discountType.code,
      stat: "INVD",
    };
    const timer = setTimeout(() => {
      setShowfinalUploading(true);
    }, 1000);
    try {
      const validfnlRes = await postData(
        Controller,
        SchmEndPoint.ValidationAllData,
        finalvldpyld,
      );
      if (validfnlRes?.Message === "Warning") {
        toast.warn("There are errors in file upload.");
        setExcelFinalerrordt(validfnlRes.Data);
        setShowErrorbtnfinal(true);
        if (filefinalInputRef.current) {
          filefinalInputRef.current.value = "";
        }
      } else {
        toast.success("Data uploaded succesfully");
        setIsFinalUpload(true);
        setMappedCustProddata(excelValidateFinaldta);
        // setExcelFinaldta(validfnlRes.Data);
      }
    } catch (error: any) {
    } finally {
      clearTimeout(timer);
      setTempfinalUpLoading(false);
      setShowfinalUploading(false);
    }
  };
  const fieldMap: Record<string, string> = {
    COMMON_FIELD: `${schmUploadType?.Name} Name`,
    PRODUCT_CODE: "Product Code",
    PCK_DISC: "Pack Discount",
    CSE_DISK: "Case Discount",
  };

  function renameFields(
    rows: Record<string, any>[],
    map: Record<string, string>,
  ) {
    return rows.map((row) => {
      const newRow: Record<string, any> = {};

      Object.keys(row).forEach((key) => {
        const newKey = map[key] || key;
        newRow[newKey] = row[key];
      });

      return newRow;
    });
  }

  let downloadcatdata = async () => {
    let typedt = selectedSchm[0]?.UPLOAD_TYPE == 10 ? "C" : "S";
    const catdatRes = await fetchData(
      Controller,
      `${SchmEndPoint.GetSchemeWiseCustSegdata}`,
      `SCHEME_CODE=${schmCode}&type=${typedt}`,
    );
    let fileName = `CategoryWiseData.xlsx`;
    downloadExcelDateFormat(catdatRes.Data, fileName);
  };

  const excelErrorFinlDownload = () => {
    let flname = `${schmUploadType.Name}wise_Schm_error.xlsx`;
    if (excelFinalerrordt?.length > 0) {
      const result = renameFields(excelFinalerrordt, fieldMap);
      downloadExcelDateFormat(result, flname);
    }
  };

  let UpdateSchmDisc = async () => {
    let updateSchmpld = {
      scheme_code: schemeCodeOriginal,
      end_date: format(schmenddt ?? "", "dd/MM/yyyy"),
      status: activationsts == "Active" ? "Y" : "N",
      user_id: UserId,
    };
    setWhileSave(true);
    try {
      const updtschm = await postData(
        Controller,
        SchmEndPoint.UpdateLineLvlschm,
        updateSchmpld,
      );
      toast.success(`${updtschm.Message}`);
      nav("/Master/Scheme/SchemeDiscDefAllRec");
      setWhileSave(false);
    } catch (error: any) {
      toast.error(`${error.response.data.Message}`);
    } finally {
      setWhileSave(false);
    }
  };

  //#endregion
  return (
    <main>
      <div className="col-12">
        <div className="row">
          <div className="col-lg-4 col-md-12 col-sm-12">
            <h6 className="py-2">Individual Discount</h6>
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12">
            {!viewSchmDetls && (
              <div className="col-12">
                <div className="text-end">
                  <button
                    type="button"
                    className="btn anime-btn"
                    onClick={UpdateSchmDisc}
                    disabled={whileSave || updateDisable}
                  >
                    Update
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="col-12">
          <section className="sales-box">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Scheme Code</label>
                  <InputText
                    placeholder="Code will be generated on Save"
                    value={schemeCodeOriginal}
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Scheme Name</label>
                  <InputText
                    placeholder="Enter scheme name"
                    value={schemeName}
                    disabled={!viewSchmDetls}
                    onChange={(e) => {
                      setSchemeName(e.target.value);
                      setErrors({ ...errors, schemeName: null });
                    }}
                    className={
                      submitted && errors.schemeName
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                  />
                  {submitted && errors.schemeName && (
                    <small className="p-error">{errors.schemeName}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Start Date</label>
                  <Calendar
                    value={schmstartdt}
                    placeholder="Select start date"
                    disabled={!viewSchmDetls}
                    onChange={(e) => {
                      setSchmstartdt(e.value as Date);
                      setErrors({ ...errors, schmstartdt: null });
                    }}
                    dateFormat="dd/mm/yy"
                    minDate={tomorrow}
                    showMinMaxRange
                    showIcon
                    className={
                      submitted && errors.schmstartdt
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                  />
                  {submitted && errors.schmstartdt && (
                    <small className="p-error">{errors.schmstartdt}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">End Date</label>
                  <Calendar
                    value={schmenddt}
                    placeholder="Select end date"
                    onChange={(e) => {
                      setSchmenddt(e.value as Date);
                      setErrors({ ...errors, schmenddt: null });
                    }}
                    dateFormat="dd/mm/yy"
                    minDate={viewSchmDetls ? schmstartdt : tomorrow}
                    showMinMaxRange
                    // minDate={tomorrow}
                    className={
                      submitted && errors.schmenddt
                        ? "p-invalid w-100"
                        : "w-100"
                    }
                    showIcon
                    // disabled={
                    //   isEndDateToday || selectedSchm[0]?.IS_ACTIVE == "Inactive"
                    // }
                  />
                  {submitted && errors.schmenddt && (
                    <small className="p-error">{errors.schmenddt}</small>
                  )}
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="d-block mb-2">
                  <label className="form-label">Discount Type</label>
                  <Dropdown
                    value={discountType}
                    onChange={(e) => setDiscountType(e.value)}
                    options={discountTypeopt}
                    optionLabel="name"
                    disabled={mappedCustProddata.length > 0 || !viewSchmDetls}
                    placeholder="Select discount type"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 mt-2">
                <div className="d-block mb-2">
                  <label className="form-label d-block mb-2">
                    Activation Status
                  </label>
                  <div className="d-inline-flex">
                    <div className="flex align-items-center">
                      <RadioButton
                        inputId="Activation1"
                        name="Activation"
                        value="Active"
                        onChange={(e) => setActivationsts(e.value)}
                        checked={activationsts === "Active"}
                        disabled={updateDisable}
                        // disabled={selectedSchm[0]?.IS_ACTIVE == "Inactive"}
                      />
                      <label
                        htmlFor="Activation1"
                        className="form-label ms-2 mb-0"
                      >
                        Active
                      </label>
                    </div>
                    <div className="flex align-items-center ms-3">
                      <RadioButton
                        inputId="Activation2"
                        name="Activation"
                        value="Inactive"
                        onChange={(e) => setActivationsts(e.value)}
                        checked={activationsts === "Inactive"}
                        disabled={updateDisable}
                        // disabled={selectedSchm[0]?.IS_ACTIVE == "Inactive"}
                      />
                      <label
                        htmlFor="Activation2"
                        className="form-label ms-2 mb-0"
                      >
                        Inactive
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {!viewSchmDetls && (
            <section className="sales-box">
              <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="d-block">
                    <label className="form-label">Upload Type</label>
                    <InputText
                      value={schmUploadTypeview}
                      // onChange={(e) => {
                      //   setSchmUploadType(e.value);
                      // }}
                      disabled
                    />
                  </div>
                </div>
                {allowedTypes.has(selectedSchm[0]?.UPLOAD_TYPE) && (
                  <div className="col-lg-9 col-md-6 col-sm-12">
                    <div className="text-end mt-4">
                      <button
                        type="button"
                        className="btn anime-btn"
                        onClick={downloadcatdata}
                      >
                        Download categorywise data
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </section>
          )}

          {viewSchmDetls && (
            <>
              <section className="sales-box">
                <div className="row mb-3">
                  <div className="col-lg-3 col-md-12 col-sm-12">
                    <div className="d-block">
                      <label className="form-label">Upload Type</label>
                      <Dropdown
                        value={schmUploadType}
                        onChange={(e) => {
                          setSchmUploadType(e.value);
                          setSelectedstate([]);
                          setSelectedRegion([]);
                          setSourceDist([]);
                          setTargetDist([]);
                          setStreamType(null);
                          setMappedCustProddata([]);
                          setExcelCustData([]);
                          setErrors({ ...errors, schmUploadType: null });
                        }}
                        options={schmUploadTypeOption}
                        optionLabel="Code"
                        placeholder="Select a Upload Type"
                        disabled={
                          sourceDist?.length > 0 ||
                          mappedCustProddata?.length > 0
                        }
                      />
                      {submitted && errors?.schmUploadType && (
                        <small className="p-error">
                          {errors?.schmUploadType}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-12 col-sm-12">
                    {schmUploadType?.ID == "15" && (
                      <div className="d-block">
                        <label className="form-label">Filter Type</label>
                        <Dropdown
                          value={segSpecific}
                          onChange={(e) => {
                            setSegSpecific(e.value);
                          }}
                          options={segSpecificOpt}
                          disabled={mappedCustProddata.length > 0}
                          optionLabel="name"
                          placeholder="Select a Upload Type"
                        />
                      </div>
                    )}
                  </div>

                  {
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <div className="text-end mt-4">
                        <button
                          type="button"
                          className="btn anime-btn"
                          onClick={() => setResetPopup(true)}
                          disabled={schmUploadType == null}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  }
                </div>

                <div className="row">
                  {(schmUploadType?.Name == "Customer" ||
                    schmUploadType?.Name == "Distributor") && (
                    <>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">Stream</label>
                          <Dropdown
                            value={streamType}
                            onChange={(e) => {
                              setStreamType(e.value);
                              setErrorsDist((prev) => ({
                                ...prev,
                                stream: false,
                              }));
                              // setTargetDist([]);
                              // setSourceDist([]);
                              // setCustSegType("All");
                            }}
                            disabled={sourceDist?.length > 0}
                            options={streamTypeopt}
                            optionLabel="name"
                            placeholder="Select a Stream Type"
                            className={errorsDist?.stream ? "p-invalid" : ""}
                          />
                          {errorsDist?.stream && (
                            <small className="text-danger">
                              Stream is required
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">Region</label>
                          <MultiSelect
                            value={selectedRegion}
                            onChange={(e) => {
                              handleRegion(e);
                              setSelectedstate([]);
                              setErrorsDist((prev) => ({
                                ...prev,
                                region: false,
                              }));
                            }}
                            options={region}
                            filter
                            selectAllLabel="Select All"
                            optionLabel="Region_Description"
                            placeholder="Select Region"
                            className={`w-100 ${
                              errorsDist.region ? "p-invalid" : ""
                            }`}
                          />
                          {errorsDist.region && (
                            <small className="text-danger">
                              Region is required
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">State</label>
                          <MultiSelect
                            value={selectedstate}
                            onChange={(e) => {
                              setSelectedstate(e.value);
                              setErrorsDist((prev) => ({
                                ...prev,
                                state: false,
                              }));
                            }}
                            filter
                            options={state}
                            selectAllLabel="Select All"
                            optionLabel="State_Name"
                            placeholder="Select State"
                            className={`w-100 ${errorsDist.state ? "p-invalid" : ""}`}
                          />
                          {errorsDist.state && (
                            <small className="text-danger">
                              State is required
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="text-end mt-4">
                          <button
                            type="button"
                            className="btn anime-btn"
                            onClick={populateDistlst}
                          >
                            Get Distributor
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {schmUploadType?.Name == "Segment" && (
                    <>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">Stream</label>
                          <Dropdown
                            value={streamType}
                            onChange={(e) => {
                              setStreamType(e.value);
                            }}
                            options={streamTypeopt}
                            optionLabel="name"
                            disabled={fileUpload}
                            placeholder="Select a Stream Type"
                            className={errorsDist.stream ? "p-invalid" : ""}
                          />
                        </div>
                      </div>
                      {segSpecific?.code == "REGN" &&
                        schmUploadType?.ID == "15" && (
                          <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="d-block">
                              <label className="form-label">Region</label>
                              <MultiSelect
                                value={selectedRegion}
                                onChange={(e) => {
                                  handleRegion(e);
                                  setSelectedstate([]);
                                }}
                                options={region}
                                filter
                                selectAllLabel="Select All"
                                optionLabel="Region_Description"
                                placeholder="Select Region"
                              />
                            </div>
                          </div>
                        )}
                      {segSpecific?.code == "STAT" &&
                        schmUploadType?.ID == "15" && (
                          <>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                              <div className="d-block">
                                <label className="form-label">Region</label>
                                <MultiSelect
                                  value={selectedRegion}
                                  onChange={(e) => {
                                    handleRegion(e);
                                    setSelectedstate([]);
                                  }}
                                  options={region}
                                  filter
                                  selectAllLabel="Select All"
                                  optionLabel="Region_Description"
                                  placeholder="Select Region"
                                />
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                              <div className="d-block">
                                <label className="form-label">State</label>
                                <MultiSelect
                                  value={selectedstate}
                                  onChange={(e) => {
                                    setSelectedstate(e.value);
                                  }}
                                  filter
                                  options={state}
                                  selectAllLabel="Select All"
                                  optionLabel="State_Name"
                                  placeholder="Select State"
                                />
                              </div>
                            </div>
                          </>
                        )}
                      {segSpecific?.code == "DIST" &&
                        schmUploadType?.ID == "15" && (
                          <>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                              <div className="d-block">
                                <label className="form-label">Region</label>
                                <MultiSelect
                                  value={selectedRegion}
                                  onChange={(e) => {
                                    handleRegion(e);
                                    setSelectedstate([]);
                                    setErrorsDist((prev) => ({
                                      ...prev,
                                      region: false,
                                    }));
                                  }}
                                  options={region}
                                  filter
                                  selectAllLabel="Select All"
                                  optionLabel="Region_Description"
                                  placeholder="Select Region"
                                  className={`w-100 ${
                                    errorsDist.region ? "p-invalid" : ""
                                  }`}
                                />
                                {errorsDist.region && (
                                  <small className="text-danger">
                                    Region is required
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                              <div className="d-block">
                                <label className="form-label">State</label>
                                <MultiSelect
                                  value={selectedstate}
                                  onChange={(e) => {
                                    setSelectedstate(e.value);
                                    setErrorsDist((prev) => ({
                                      ...prev,
                                      state: false,
                                    }));
                                  }}
                                  filter
                                  options={state}
                                  selectAllLabel="Select All"
                                  optionLabel="State_Name"
                                  placeholder="Select State"
                                  className={`w-100 ${errorsDist.state ? "p-invalid" : ""}`}
                                />
                                {errorsDist.state && (
                                  <small className="text-danger">
                                    State is required
                                  </small>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                              <div className="text-end mt-4">
                                <button
                                  type="button"
                                  className="btn anime-btn"
                                  onClick={populateDistlst}
                                >
                                  Get Distributor
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                    </>
                  )}
                  {schmUploadType?.Name == "Region" && (
                    <>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">Stream</label>
                          <Dropdown
                            value={streamType}
                            onChange={(e) => {
                              setStreamType(e.value);
                            }}
                            options={streamTypeopt}
                            optionLabel="name"
                            disabled={fileUpload}
                            placeholder="Select a Stream Type"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">Region</label>
                          <MultiSelect
                            value={selectedRegion}
                            onChange={(e) => {
                              handleRegion(e);
                              setSelectedstate([]);
                            }}
                            options={region}
                            filter
                            selectAllLabel="Select All"
                            optionLabel="Region_Description"
                            placeholder="Select Region"
                          />
                        </div>
                      </div>
                    </>
                  )}
                  {schmUploadType?.Name == "State" && (
                    <>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">Stream</label>
                          <Dropdown
                            value={streamType}
                            onChange={(e) => {
                              setStreamType(e.value);
                            }}
                            options={streamTypeopt}
                            optionLabel="name"
                            disabled={fileUpload}
                            placeholder="Select a Stream Type"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">Region</label>
                          <MultiSelect
                            value={selectedRegion}
                            onChange={(e) => {
                              handleRegion(e);
                              setSelectedstate([]);
                            }}
                            options={region}
                            filter
                            selectAllLabel="Select All"
                            optionLabel="Region_Description"
                            placeholder="Select Region"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">State</label>
                          <MultiSelect
                            value={selectedstate}
                            onChange={(e) => {
                              setSelectedstate(e.value);
                            }}
                            filter
                            options={state}
                            selectAllLabel="Select All"
                            optionLabel="State_Name"
                            placeholder="Select State"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {(schmUploadType?.Name == "Customer" ||
                  schmUploadType?.Name == "Distributor" ||
                  (schmUploadType?.ID == 15 &&
                    segSpecific?.code == "DIST")) && (
                  <div className="border rounded bg-white p-3 mt-3">
                    {(schmUploadType?.Name == "Distributor" ||
                      (schmUploadType?.ID == 15 &&
                        segSpecific?.code == "DIST")) && (
                      <div className="d-inline-flex mb-3">
                        <div className="flex align-items-center">
                          <RadioButton
                            inputId="prodSelrction1"
                            name="Picklist"
                            value="Picklist"
                            onChange={(e) => setDistSelcen(e.value)}
                            checked={distSelcen === "Picklist"}
                            disabled={isDistUpload}
                          />
                          <label
                            htmlFor="prodSelrction1"
                            className="form-label ms-2 mb-0"
                          >
                            Select Distributors
                          </label>
                        </div>
                        <div className="flex align-items-center ms-3">
                          <RadioButton
                            inputId="prodSelrction2"
                            name="Upload"
                            value="Upload"
                            onChange={(e) => setDistSelcen(e.value)}
                            checked={distSelcen === "Upload"}
                            disabled={isDistUpload}
                          />
                          <label
                            htmlFor="prodSelrction2"
                            className="form-label ms-2 mb-0"
                          >
                            Upload Distributors
                          </label>
                        </div>
                      </div>
                    )}
                    <div className="PickListPanel">
                      {distSelcen === "Picklist" && (
                        <PickListSchem
                          source={sourceDist}
                          target={targetDist}
                          itemTemplatePanel={itemTemplatePanelDist}
                          sourceHeader="Available Distributor"
                          targetHeader="Selected Distributor"
                          filterby="Distributor_Code,Distributor_Name"
                          datakeystr="Distributor_Code"
                          onChange={(newSource, newTarget) => {
                            setSourceDist(newSource);
                            setTargetDist(newTarget);
                          }}
                          mainHeader="Distributor"
                          disabled={false}
                        />
                      )}

                      {distSelcen === "Upload" && (
                        <div className="row">
                          <div className="col-lg-5 col-md-5 col-sm-12">
                            <button
                              type="button"
                              className="btn anime-secondary-btn"
                              onClick={downloadTemptDist}
                              disabled={tempDistLoading}
                            >
                              Download Template{" "}
                              <Fa.FaDownload className="ms-2" />
                            </button>
                          </div>
                          <div className="col-lg-7 col-md-7 col-sm-12 text-end">
                            <input
                              type="file"
                              accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                              id="formFile"
                              ref={fileuploadDistRef}
                              onChange={handleDistFileUploadXL}
                            />

                            <button
                              type="button"
                              className="btn anime-btn me-3"
                              onClick={handleDistValidateCustXL}
                              disabled={
                                tempDistUpLoading || excelDistData.length === 0
                              }
                            >
                              {tempDistUpLoading
                                ? "Uploading..."
                                : "Upload File"}
                            </button>
                            {showDistErrorbtn && (
                              <button
                                type="button"
                                className="btn anime-red-btn"
                                onClick={excelErrorDistDownload}
                              >
                                Error File
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {((schmUploadType?.Name == "Customer" &&
                  targetDist.length > 0) ||
                  (schmUploadType?.Name == "Segment" &&
                    streamType != null)) && (
                  <div className="border rounded bg-white p-3 mt-3">
                    <div className="row mb-2">
                      <div className="col-lg-6 col-md-12 col-sm-12">
                        <h6 className="text-success">
                          For {schmUploadType?.Name}
                        </h6>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12">
                        <h6 className="text-success">
                          <div className="text-end">
                            {fileUpload && (
                              <small className="text-success">
                                <i>
                                  File Uploaded Successfully{" "}
                                  <Fa.FaCheckCircle className="ms-1" />
                                </i>
                              </small>
                            )}
                          </div>
                        </h6>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-5 col-md-6 col-sm-12">
                        <button
                          type="button"
                          className="btn anime-secondary-btn"
                          onClick={downlodTempt}
                          disabled={tempLoading}
                        >
                          {tempLoading ? "Loading..." : "Download Template"}{" "}
                          {tempLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <Fa.FaDownload className="ms-2" />
                          )}
                        </button>
                        <small className="text-danger d-inline-block ms-2">
                          <i>*All Available {schmUploadType?.Name}*</i>
                        </small>
                      </div>
                      <div className="col-lg-7 col-md-6 col-sm-12 text-end">
                        <input
                          type="file"
                          accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          id="formFile"
                          ref={fileInputRef}
                          onChange={handleFileUploadXL}
                          disabled={fileUpload}
                        />

                        <button
                          type="button"
                          className="btn anime-btn me-3"
                          onClick={handleValidateCustXL}
                          disabled={
                            excelCustdata?.length == 0 ||
                            showUploading ||
                            tempUpLoading ||
                            fileUpload
                          }
                        >
                          {tempUpLoading
                            ? showUploading
                              ? "Uploading..."
                              : "Validating..."
                            : "Upload File"}
                        </button>
                        {showErrorbtn && (
                          <button
                            type="button"
                            className="btn anime-red-btn "
                            onClick={excelErrorCustDownload}
                          >
                            Error File
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </section>

              <section className="sales-box">
                {(schmUploadType?.Name == "Customer" ||
                  schmUploadType?.Name == "Segment") &&
                  prodSelcen === "Picklist" && (
                    <div className="row mb-3">
                      <div className="col-lg-5 col-md-12 col-sm-12">
                        <div className="d-block">
                          <label className="form-label">Category</label>
                          <Dropdown
                            value={selectedCategory}
                            onChange={(e) => {
                              setSelectedCategory(e.value);
                            }}
                            disabled={!fileUpload}
                            options={listofCategory}
                            optionLabel="Valuename"
                            placeholder="Select a Category Type"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                <div className="border rounded bg-white p-3">
                  <div className="row mb-2">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <div className="d-inline-flex">
                        <div className="flex align-items-center">
                          <RadioButton
                            inputId="prodSelrction1"
                            name="Picklist"
                            value="Picklist"
                            onChange={(e) => setProdSelcen(e.value)}
                            checked={prodSelcen === "Picklist"}
                            disabled={mappedCustProddata.length > 0}
                          />
                          <label
                            htmlFor="prodSelrction1"
                            className="form-label ms-2 mb-0"
                          >
                            Select Products
                          </label>
                        </div>
                        <div className="flex align-items-center ms-3">
                          <RadioButton
                            inputId="prodSelrction2"
                            name="Upload"
                            value="Upload"
                            onChange={(e) => setProdSelcen(e.value)}
                            checked={prodSelcen === "Upload"}
                            disabled={mappedCustProddata.length > 0}
                          />
                          <label
                            htmlFor="prodSelrction2"
                            className="form-label ms-2 mb-0"
                          >
                            Upload Products
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <h6 className="text-success">
                        <div className="text-end">
                          {prodUploadsuccss && (
                            <small className="text-success">
                              <i>
                                File Uploaded Successfully{" "}
                                <Fa.FaCheckCircle className="ms-1" />
                              </i>
                            </small>
                          )}
                        </div>
                      </h6>
                    </div>
                  </div>
                  <div className="WholePicklistPanel">
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                      {prodSelcen === "Picklist" ? (
                        <div className="PickListPanel">
                          <PickListSchem
                            source={sourceProd}
                            target={targetProd}
                            itemTemplatePanel={itemTemplatePanelProd}
                            sourceHeader="Available Products"
                            targetHeader="Selected Products"
                            filterby="Product_ID,Product_Description"
                            datakeystr="Product_ID"
                            onChange={(newSource, newTarget) => {
                              setSourceProd(newSource);
                              setTargetProd(newTarget);
                            }}
                            mainHeader="Products"
                            disabled={false}
                          />
                        </div>
                      ) : (
                        <>
                          <div className="row">
                            <div className="col-lg-5 col-md-5 col-sm-12">
                              <button
                                type="button"
                                className="btn anime-secondary-btn"
                                onClick={downloadTeampltprod}
                                disabled={schmUploadType == null}
                              >
                                Download Template{" "}
                                <Fa.FaDownload className="ms-2" />
                              </button>
                              <small className="text-danger d-inline-block ms-2">
                                <i>*All available Product*</i>
                              </small>
                            </div>
                            <div className="col-lg-7 col-md-7 col-sm-12 text-end">
                              <input
                                type="file"
                                accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                id="formFile"
                                ref={prodfileInputRef}
                                onChange={handleFileProdup}
                              />

                              <button
                                type="button"
                                className="btn anime-btn me-3"
                                onClick={handleValidateProdXL}
                                disabled={
                                  showUpprodloading ||
                                  tempprodUpLoading ||
                                  schmUploadType == null ||
                                  excelProdData?.length == 0
                                }
                              >
                                {tempprodUpLoading
                                  ? showUpprodloading
                                    ? "Uploading..."
                                    : "Validating..."
                                  : "Upload File"}
                              </button>
                              {showErrorbtnprod && (
                                <button
                                  type="button"
                                  className="btn anime-red-btn"
                                  onClick={excelErrorprodDownload}
                                >
                                  Error File
                                </button>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* <div className="col-lg-4 col-md-12 col-sm-12">
                      <div className="d-block">
                        <label className="form-label d-block">
                          Pack Discount {discountType?.name}
                        </label>
                        <InputNumber
                          value={pckdiscountval}
                          onValueChange={(e) => {
                            setPckDiscountval(e.value);
                          }}
                          min={1}
                          maxFractionDigits={2}
                          suffix={discountType?.code == "PERCENT" ? " %" : ""}
                          prefix={discountType?.code == "VLU" ? "₹ " : ""}
                          max={discountType?.code == "PERCENT" ? 99 : 100000}
                          placeholder="Enter here"
                          className="w-100"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12">
                      <div className="d-block">
                        <label className="form-label d-block">
                          Case Discount {discountType?.name}
                        </label>
                        <InputNumber
                          value={csediscountval}
                          onValueChange={(e) => {
                            setCseDiscountval(e.value);
                          }}
                          min={1}
                          maxFractionDigits={2}
                          suffix={discountType?.code == "PERCENT" ? " %" : ""}
                          prefix={discountType?.code == "VLU" ? "₹ " : ""}
                          max={
                            discountType?.code == "PERCENT" ? 99 : 10000000
                          }
                          placeholder="Enter here"
                          className="w-100"
                        />
                      </div>
                    </div> */}
                <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                  <div className="text-end">
                    <button
                      type="button"
                      className="btn anime-btn"
                      onClick={addproductcart}
                      disabled={IsFinalUpload}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </section>

              <section className="sales-box">
                <div className="d-block mb-3">
                  Do you want to upload the file ?
                  <InputSwitch
                    checked={wantupload}
                    onChange={(e) => setWantupload(e.value)}
                    className="switch-pos ms-2"
                  />
                </div>
                {wantupload && (
                  <div className="border rounded bg-white p-3 mb-3">
                    <div className="row">
                      <div className="col-lg-5 col-md-6 col-sm-12">
                        <button
                          type="button"
                          className="btn anime-secondary-btn"
                          onClick={downloadFinalmappedData}
                          disabled={mappedCustProddata.length == 0}
                        >
                          Download Template
                          <Fa.FaDownload className="ms-2" />
                        </button>
                        <small className="text-danger d-inline-block ms-2">
                          <i>*All Available Data*</i>
                        </small>
                      </div>
                      <div className="col-lg-7 col-md-6 col-sm-12 text-end">
                        <input
                          type="file"
                          accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          id="formFile"
                          ref={filefinalInputRef}
                          onChange={handleValidateFinalData}
                        />

                        <button
                          type="button"
                          className="btn anime-btn me-3"
                          onClick={handleFinalFileUpload}
                          disabled={
                            excelValidateFinaldta?.length == 0 ||
                            showfinalUploading ||
                            tempfinalUpLoading ||
                            mappedCustProddata.length == 0
                          }
                        >
                          {tempfinalUpLoading
                            ? showfinalUploading
                              ? "Uploading..."
                              : "Validating..."
                            : "Upload File"}
                        </button>
                        {ShowErrorbtnfinal && (
                          <button
                            type="button"
                            className="btn anime-red-btn "
                            onClick={excelErrorFinlDownload}
                          >
                            Error File
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="border rounded bg-white p-3">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row d-flex">
                      <div className="col-lg-4 col-md-4 col-sm-12">
                        <h6 className="mb-2">Records</h6>
                      </div>
                    </div>

                    <div className="DataTable">
                      <DataTable
                        value={mappedCustProddata}
                        rowGroupMode="rowspan"
                        groupRowsBy="Customer_Name"
                        sortField="Customer_Name"
                        stripedRows
                        paginator
                        rows={10}
                        scrollable
                        rowsPerPageOptions={[10, 25, 50]}
                        // tableStyle={{ minWidth: "70rem" }}
                      >
                        <Column
                          field="DIST_CODE"
                          header={
                            schmUploadType?.Name === "Customer" ||
                            schmUploadType?.Name === "Segment"
                              ? "Category"
                              : `${schmUploadType?.Name ?? ""} Code`
                          }
                        />
                        {schmUploadType?.Name !== "Customer" &&
                          schmUploadType?.Name !== "Segment" && (
                            <Column
                              field="DIST_NAME"
                              header={schmUploadType?.Name ?? "Name"}
                            />
                          )}

                        <Column field="PROD_ID" header="Product ID" />
                        <Column
                          field="PROD_DESC"
                          header="Product Description"
                        />
                        <Column
                          header={
                            discountType?.code == "PERCENT"
                              ? "Pack Percentage (%)"
                              : "Pack Amount"
                          }
                          body={(row) => (
                            <InputNumber
                              value={row.PCKDISCAMT}
                              min={0}
                              maxFractionDigits={2}
                              disabled={IsFinalUpload}
                              suffix={
                                discountType?.code == "PERCENT" ? " %" : ""
                              }
                              prefix={discountType?.code == "VLU" ? "₹ " : ""}
                              max={discountType?.code == "PERCENT" ? 99 : 1000}
                              onValueChange={(e) =>
                                onQuantityChangepck(row.id, e.value)
                              }
                              style={{ width: "100%" }}
                            />
                          )}
                        />
                        <Column
                          header={
                            discountType?.code == "PERCENT"
                              ? "Case Percentage (%)"
                              : "Case Amount"
                          }
                          body={(row) => (
                            <InputNumber
                              value={row.CSEDISCAMT}
                              min={0}
                              maxFractionDigits={2}
                              suffix={
                                discountType?.code == "PERCENT" ? " %" : ""
                              }
                              prefix={discountType?.code == "VLU" ? "₹ " : ""}
                              max={discountType?.code == "PERCENT" ? 99 : 1000}
                              disabled={IsFinalUpload}
                              onValueChange={(e) =>
                                onQuantityChangecse(row.id, e.value)
                              }
                              style={{ width: "100%" }}
                            />
                          )}
                        />
                        <Column
                          header="Action"
                          body={(row) => (
                            <button
                              className="p-button-danger p-button-text"
                              title="Delete"
                              disabled={IsFinalUpload}
                              onClick={() => deleteRow(row.id)}
                            >
                              <Fa.FaTrashAlt />
                            </button>
                          )}
                        />
                      </DataTable>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}

          {!viewSchmDetls && (
            <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
              <h6>Records</h6>
              <div className="DataTable">
                <DataTable
                  value={schmDetailsData}
                  rowGroupMode="rowspan"
                  groupRowsBy="Customer_Name"
                  sortField="Customer_Name"
                  stripedRows
                  paginator
                  rows={10}
                  scrollable
                  rowsPerPageOptions={[10, 25, 50]}
                  // tableStyle={{ minWidth: "70rem" }}
                >
                  <Column
                    field={
                      schmUploadTypeview === "Customer" ||
                      schmUploadTypeview === "Segment"
                        ? "SCHM_CATEGORY"
                        : "REF_SCHM_LEVEL_ID"
                    }
                    header={
                      schmUploadTypeview === "Customer" ||
                      schmUploadTypeview === "Segment"
                        ? "Category"
                        : `${schmUploadTypeview ?? ""} Code`
                    }
                  />
                  {schmUploadTypeview !== "Customer" &&
                    schmUploadTypeview !== "Segment" && (
                      <Column
                        field="DESCRIPTION"
                        header={schmUploadTypeview ?? "Name"}
                      />
                    )}

                  <Column field="PROD_ID" header="Product ID" />
                  <Column field="PROD_DESC" header="Product Description" />
                  <Column
                    header={
                      discountType?.code == "PERCENT"
                        ? "Pack Percentage (%)"
                        : "Pack Amount"
                    }
                    field="PACK_PERCENTAGE"
                  />
                  <Column
                    header={
                      discountType?.code == "PERCENT"
                        ? "Case Percentage (%)"
                        : "Case Amount"
                    }
                    field="CASE_PERCENTAGE"
                  />
                </DataTable>
              </div>
            </div>
          )}
        </div>

        {viewSchmDetls && (
          <div className="col-12">
            <div className="text-end">
              <button
                type="button"
                className="btn anime-btn"
                onClick={submitSchmDisc}
                disabled={whileSave || mappedCustProddata?.length == 0}
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>
      {distLoading ? <Loader /> : null}
      <ConfirmationPopUp
        visible={resetPopup}
        onHide={() => setResetPopup(false)}
        message="Continuing will remove already saved selection. Do you wish to proceed?"
        confirmLabel="Yes"
        cancelLabel="No"
        onCancel={() => setResetPopup(false)}
        onConfirm={ResetAlldata}
        onhidevisible={false}
        ConfmDis={resetloding}
      />
    </main>
  );
}
